/* eslint-disable import/prefer-default-export */
import tw, { styled } from 'twin.macro';

const fontFamily = 'Circular Std';

export const AddressFieldsWrapper = styled.div`
  ${tw`mt-5 mb-0`}
  position: relative;
  width: 100%;
`;

export const DualFieldsWrapper = styled.div`
  ${tw`m-0 p-0 flex flex-col md:flex-row justify-between md:gap-4`};
`;

export const GoogleIcon = styled.img`
  ${tw`flex ml-auto mt-2`}
  position: absolute;
  bottom: 10px;
  right: 20px;
  margin-top: 20px;
`;

export const DDBody = styled.div`
  border: 1px solid #85b7d970;
  border-top: none;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
  background-color: white;
  width: 100%;
  position: absolute;
  z-index: 200;
`;

export const OptionsList = styled.ul`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 10px 0;
  max-height: 150px;
  overflow-y: scroll;
  list-style-type: none;
  padding: 0;
`;

export const Option = styled.li`
  padding: 6px 15px;
  border-radius: 2px;
  outline-color: #eee;
  margin: 2px 0;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-family: var(--formFontType) !important;
  &.active {
    background-color: whitesmoke;
  }

  &:hover {
    background-color: #eee !important;
  }
`;

export const NoOptPlaceholder = styled.p`
  padding: 5px 15px;
  color: #999;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-family: ${fontFamily} !important;
  ${({ notInBuilder }) =>
    notInBuilder &&
    `
    font-family: var(--formFontType) !important;
  `}
`;
